module.exports = __webpack_public_path__ + "static/media/kominfo-team-10.63dcd4f2.png";